<template>
  <n-modal class="page-record-create" :loading="$var('load')" @close="$emit('close')">
    <div class="line">
      <n-card class="info" :loading="$var('load')">
        <template #header>
          <h3>Информация</h3>
        </template>
        <n-items>
          <n-input title="Проект" :value="project.title" text />
          <n-input title="Дата заполнения" v-bind="$form.input('publishedAt')" />
        </n-items>
      </n-card>
    </div>
    
    <n-card :loading="$var('load')">
      <template #header>
        <h3>{{ journal.title }}</h3>
      </template>
      <n-items>
        <n-input title="№№ пп" v-bind="$form.input('number')" />
        <n-input title="Код защиты" v-bind="$form.input('code')" />
        <n-input title="Наименование защиты" v-bind="$form.input('title')" />
        <n-datepicker title="Дата настройки и проверки" v-bind="$form.input('date')" inline />
        <n-input title="Готовность защиты" v-bind="$form.input('ready')" />
        <n-input title="Фамилия, инициалы" v-bind="$form.input('name')" />
      </n-items>
    </n-card>
    
    <n-card>
      <n-divide>
        <div></div>
        <n-button color="success" @click="save">Сохранить</n-button>
      </n-divide>
    </n-card>
  </n-modal>
</template>

<script>
export default {
  name: 'PageRecordCreate',
  props: [ 'project', 'journal', ],
  data() {
    return {
      figures: [],
    }
  },
  created() {
    this.$form.init({
      publishedAt: $app.date.format($app.date.now()),
    })
  },
  methods: {
    save() {
      this.$var('load', true)
      const data = {
        record: this.$form.get(),
      }
      $api.journals.spec62.second.create(this.project.id, data).then((response) => {
        this.$emit('reload')
        this.$emit('close')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .page-record-create {
    
    .line {
      display: flex;
      align-items: flex-start;
      
      & > * {
        white-space: normal;
        display: inline-block;
        margin-bottom: 0;
        flex-grow: .4;
        flex-basis: 1px;
      }
      .items {
        margin-left: 0;
        flex-grow: .6;
      }
    }
    
    
    .weather {
      .unit {
        margin: 0 20px 0 5px;
      }
      .temperature {
        margin-left: 20px;
      }
      .temperature, .wind {
        width: 100px;
      }
    }
    
    .add {
      margin-top: 5px;
      font-size: .8em;
      opacity: .7;
      cursor: pointer;
    }
  }
</style>
